<template>
  <div class="login">
    <div class="select-os">
        <input type="radio" id="japanese" name="launguage" v-model="style" value="0" class="japanese" checked>
        <label for="japanese">
            日本語
        </label>
        <input type="radio" id="english" name="launguage" v-model="style" value="1" class="english">
        <label for="english">
            English
        </label>
    </div>

    <div id="top">

      <div class="card-content" v-if="style === '0'">
        <Loading v-show="loading"></Loading>
        <h1><img src="https://kirarin-covid19.com/img/siteid.png" ></h1>
      <input type="text" placeholder="メールアドレス" v-model="mail">
      <button id="login" @click="signIn">ユーザー認証</button>
      <!--<p>本サービスに関する<a href="#" style="color: #5D99FF;">利用規約</a>はこちらへ。</p>-->
      </div>

      <div class="card-content" v-else>
        <Loading v-show="loading"></Loading>
        <h1><img src="https://kirarin-covid19.com/img/siteid.png" ></h1>
      <input type="text" placeholder="email address" v-model="mail">
      <button id="login" @click="signIn">User Authentication</button>
      <!--<p>Confirm <a href="#" style="color: #5D99FF;">Our Terms</a> Of Service</p>-->
      </div>

    </div>
    <Footer/>
  </div>
</template>
<style scoped>
#top img{width: 60%;margin-top: 5%;margin-bottom: 5%;}
#top{position: absolute;top: 50%;left: 50%;width: 30%;transform: translateY(-50%) translateX(-50%);box-shadow: 10px 10px 10px 10px rgba(0,0,0,0.4);}
#top input{
  display: block;
  width: 90%;
  height: 40px;
  margin: 16px auto;
  font-size: 1em;
}

h1{
 margin: 0px;
}
body{
  margin: 0px;
}
#top #login{
display: block;
  width: 80%;
  line-height: 40px;
  height: 40px;
  margin: 8% auto;
  text-align: center;
  font-size: 1em;
  text-align: center;
  background: #5D99FF;
  text-transform: uppercase;
  text-decoration: none;
  color: white;
  border:0px;
  border-radius: 4px;
}
.fullview {
  background: rgba(0,0,0,0.4);
}
circle{
background: red!important;
}
#top #login:hover{
  opacity: 0.7;
}
.card-content{
  padding:8px;
  width: 100%;
  height: auto;
  background-color: white;
  margin: 0 auto;
}
@media screen and (max-width:780px) {
#top img{width: 80%;margin-top: 5%;margin-bottom: 5%;}
#top{position: absolute;top: 50%;left: 50%;width: 80%;transform: translateY(-50%) translateX(-50%);box-shadow: 10px 10px 10px 10px rgba(0,0,0,0.4);}
.card-content p{font-size: .8em;}
}
.select-os{
  text-align: end;
  margin-top: 2em;
  margin-right: 2em;
}
.select-os input {
  display: none;
}
.select-os input[type="radio"]:checked.japanese + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os input[type="radio"]:checked.english + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os label {
  color: #ddd;
  border: 2px solid #ddd;
  text-align: center;
  display: inline-block;
  padding: 5px 0px;
  width: 120px;
}
.select-os label:hover {
    color: #aaa;
    border: 2px solid #aaa;
    cursor: pointer;
}
</style>
<script>
import $ from 'jquery'
import Loading from './common/Loading'
import Footer from './common/Footer'
import firebase from 'firebase'
export default {
  name: 'Login',
  components: {
    Loading, Footer
  },
  data () {
    return {
      db: null,
      loading: null,
      mail: null,
      msg: 'Welcome to 株式会社Kirarin様',
      tokenId: null,
      hotel: null,
      plan: null,
      style: null,
      mailPattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
    }
  },
  created: function () {
    // セキュリティのためローカルにあるuserIdは正しいかチェック
    this.loading = true
    this.db = firebase.firestore()
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.hotel = result['place']
    this.plan = parseInt(result['plan'], 10)

    if (!result['style']) {
      this.style = '0'
    } else {
      this.style = result['style']
    }

    

    //パーティ参加者様事前PCR検査の場合企業様情報入力に画面遷移
    if (this.plan === 1) {
      location.href = "/contactParty?style=" + this.style + "&place=" + this.hotel
      return
    } else {
      this.loading = false
    }

  },
  methods: {
    signIn: function () {
      this.loading = true
      // planNameとplaceNameがNullの場合、不正アクセスのポップ
      if (!this.hotel) {
        if (this.style === '0') {
          alert('不正アクセスの可能性があります、お問い合わせページから担当へご連絡ください。')
        } else {
          alert('There is a possibility of unauthorized access.Please make inquiries using the contact form.')
        }
        this.loading = false
        location.href = "/contact?style=" + this.style + "&place=" + this.hotel
        return
      }
      if (!this.plan) {
        if (this.plan != 0) {
          if (this.style === '0') {
            alert('不正アクセスの可能性があります、お問い合わせページから担当へご連絡ください。')
          } else {
            alert('There is a possibility of unauthorized access.Please make inquiries using the contact form.')
          }
          this.loading = false
          location.href = "/contact?style=" + this.style + "&place=" + this.hotel
          return
        }
      }
      // ユーザー情報への登録有無を確認し、新規であれば登録、既存に登録されているのであればパスコードを更新する
      if (!this.mail) {
        if (this.style === '0') {
            alert('メールアドレスが入力されていません。')
        } else {
            alert('Email has not been filled in.')
        }
        this.loading = false
        return
      }
      // メールアドレスのバリデーション
      if (!this.mailPattern.test(this.mail)) {
        if (this.style === '0') {
            alert('メールアドレスの入力が正しくありません。')
        } else {
            alert('Email has not been filled in.')
        }
        this.loading = false
        return
      }

      var exist = false
      let self = this
      this.db.collection('users').where('mail', '==', this.mail).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // パスコードを更新後、phpメール送信
          exist = true
          console.log('更新する')
          const passcode = ('0000000' + Math.floor(Math.random() * 10000000)).slice(-6)
          console.log(passcode)

          // パスコード更新
          const docRef = self.db.collection('users').doc(doc.id)
          docRef.update({
            mail: self.mail,
            passcode: passcode,
            place: self.hotel,
            plan: self.plan}).then(function () {

            var data = { 'mail': self.mail, 'place': self.hotel, 'plan': parseInt(self.plan, 10), 'passcode': passcode }

            var url = null
            if (self.style === '0') {
                url = 'https://weart-marketing.com/api/confirm/'
            } else {
                url = 'https://weart-marketing.com/api/confirm/en/'
            }

            $.ajax({
              url: url,
              type: 'POST',
              data: data
            }).done(function (data) {
              if (self.style === '0') {
                  alert('送信完了しました。メールアドレスをご確認ください。')
              } else {
                  alert('Message sent successfully. Please check your email.')
              }
            }).fail(function () {
              if (self.style === '0') {
                  alert('一時的なサーバーエラーが発生しました。')
              } else {
                  alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
            })
            
            self.loading = false
          }).catch(function () {
            if (self.style === '0') {
                alert('一時的なサーバーエラーが発生しました。')
            } else {
                alert('System error has temporarily occurred.')
            }
            self.loading = true
            location.href = "/error?style=" + self.style
            self.isUpdateModal = false
          })
        })
        if (!exist) {
          // ユーザーを新規登録し、phpメール送信
          console.log('新規登録する')
          const passcode = ('0000000' + Math.floor(Math.random() * 10000000)).slice(-6)
          console.log(passcode)

          // ユーザー登録
          let collection = self.db.collection('users')
          var doc = {
              mail: self.mail,
              passcode: passcode,
              place: self.hotel,
              plan: self.plan
          }
          collection.add(doc).then(function (docRef) {
            // メール送信
            var data = { 'mail': self.mail, 'place': self.hotel, 'plan': parseInt(self.plan, 10), 'passcode': passcode }

            var url = null
            if (self.style === '0') {
                url = 'https://weart-marketing.com/api/confirm/'
            } else {
                url = 'https://weart-marketing.com/api/confirm/en/'
            }

            $.ajax({
              url: url,
              type: 'POST',
              data: data
            }).done(function (data) {
              if (self.style === '0') {
                alert('送信完了しました。メールアドレスをご確認ください。')
              } else {
                alert('Message sent successfully. Please check your email.')
              }
              self.loading = false
            }).fail(function () {
              if (self.style === '0') {
                  alert('一時的なサーバーエラーが発生しました。')
              } else {
                  alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
            })
              
          }).catch(function (error) {
              if (self.style === '0') {
                  alert('一時的なサーバーエラーが発生しました。')
              } else {
                  alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
          })

        }
      }).catch(function (error) {
        console.log(error)
        if (self.style === '0') {
          alert('一時的なサーバーエラーが発生しました。')
        } else {
          alert('System error has temporarily occurred.')
        }
        location.href = "/error?style=" + self.style
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue